/**
 * SealedVsOpenVented — side-by-side animated comparison of sealed vs open-vented systems.
 */

export function SealedVsOpenVented() {
  return (
    <figure style={{ margin: 0 }}>
      <svg viewBox="0 0 520 260" width="100%" role="img" aria-label="Sealed vs open-vented system comparison">
        <title>Sealed pressurised system vs open-vented system with F&amp;E tank</title>
        <defs>
          <style>{`
            .sov-pipe { stroke: #64748b; stroke-width: 2.5; fill: none; }
            .sov-flow { stroke: #3b82f6; stroke-width: 2; fill: none; opacity: 0.5; stroke-dasharray: 6,5; animation: sov-dash 1.2s linear infinite; }
            .sov-label { font-family: system-ui, sans-serif; font-size: 11px; fill: #475569; text-anchor: middle; }
            .sov-heading { font-family: system-ui, sans-serif; font-size: 13px; fill: #1e293b; font-weight: 600; text-anchor: middle; }
            .sov-component { fill: #f1f5f9; stroke: #475569; stroke-width: 1.5; }
            .sov-divider { stroke: #cbd5e1; stroke-width: 1; stroke-dasharray: 4,4; }
            @keyframes sov-dash { to { stroke-dashoffset: -11; } }
          `}</style>
        </defs>

        {/* Divider */}
        <line x1="260" y1="30" x2="260" y2="250" className="sov-divider" />

        {/* === OPEN-VENTED (left) === */}
        <text x="130" y="20" className="sov-heading">Open-vented</text>

        {/* F&E tank in loft */}
        <rect x="100" y="35" width="60" height="25" rx="3" className="sov-component" />
        <text x="130" y="52" className="sov-label">F&amp;E tank</text>

        {/* Vent pipe up to tank */}
        <line x1="130" y1="60" x2="130" y2="100" className="sov-pipe" />

        {/* Boiler */}
        <rect x="90" y="100" width="80" height="40" rx="6" fill="#fef3c7" stroke="#f59e0b" strokeWidth="2" />
        <text x="130" y="125" className="sov-label">Boiler</text>

        {/* Flow to radiators */}
        <line x1="130" y1="140" x2="130" y2="170" className="sov-pipe" />
        <line x1="130" y1="140" x2="130" y2="170" className="sov-flow" />

        {/* Radiator */}
        <rect x="100" y="170" width="60" height="30" rx="4" className="sov-component" />
        <text x="130" y="190" className="sov-label">Radiators</text>

        {/* Open to atmosphere arrow */}
        <line x1="130" y1="35" x2="130" y2="28" className="sov-pipe" />
        <polygon points="125,30 130,22 135,30" fill="#64748b" />
        <text x="130" y="220" className="sov-label" style={{ fontSize: '10px', fill: '#94a3b8' }}>
          Open to atmosphere
        </text>

        {/* === SEALED (right) === */}
        <text x="390" y="20" className="sov-heading">Sealed</text>

        {/* Expansion vessel */}
        <ellipse cx="390" cy="50" rx="25" ry="15" className="sov-component" />
        <text x="390" y="55" className="sov-label" style={{ fontSize: '10px' }}>EV</text>

        {/* Pressure gauge */}
        <circle cx="340" cy="50" r="12" className="sov-component" />
        <text x="340" y="54" className="sov-label" style={{ fontSize: '9px' }}>bar</text>

        {/* Connection to boiler */}
        <line x1="365" y1="62" x2="390" y2="100" className="sov-pipe" />

        {/* Boiler */}
        <rect x="350" y="100" width="80" height="40" rx="6" fill="#dbeafe" stroke="#3b82f6" strokeWidth="2" />
        <text x="390" y="125" className="sov-label">Boiler</text>

        {/* Flow to radiators */}
        <line x1="390" y1="140" x2="390" y2="170" className="sov-pipe" />
        <line x1="390" y1="140" x2="390" y2="170" className="sov-flow" />

        {/* Radiator */}
        <rect x="360" y="170" width="60" height="30" rx="4" className="sov-component" />
        <text x="390" y="190" className="sov-label">Radiators</text>

        <text x="390" y="220" className="sov-label" style={{ fontSize: '10px', fill: '#94a3b8' }}>
          Sealed — no oxygen ingress
        </text>

        {/* Comparison notes */}
        <text x="130" y="245" className="sov-label" style={{ fill: '#dc2626', fontSize: '10px' }}>
          Oxygen promotes corrosion
        </text>
        <text x="390" y="245" className="sov-label" style={{ fill: '#059669', fontSize: '10px' }}>
          Higher pressure, no corrosion risk
        </text>
      </svg>
    </figure>
  );
}
